import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Button, Card } from 'react-bootstrap';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      <Card className="text-center p-5">
        <Card.Body>
          <h1 className="display-1">404</h1>
          <h2 className="mb-4">דף לא נמצא</h2>
          <p className="mb-4">הדף שביקשת לא קיים במערכת.</p>
          <Button variant="primary" onClick={() => navigate('/')}>
            חזרה לדף הבית
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default NotFound;

